"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKIP_OPERATION_NAME_CHECK = exports.OrderStates = exports.VendorType = exports.Interactions = exports.ItemType = exports.ProductType = exports.ProductName = exports.GRAPHQL_AUTHENTICATION_ERRORS = exports.GRAPHQL_BAD_REQUEST_ERRORS = exports.Level = exports.GraphQLOperations = exports.ErrorType = void 0;
var ErrorType;
(function (ErrorType) {
    ErrorType["SERVER"] = "server";
    ErrorType["AUTHORIZATION"] = "auth";
    ErrorType["INLINE"] = "inline";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
var GraphQLOperations;
(function (GraphQLOperations) {
    GraphQLOperations["GET_PRICING"] = "getPricingByExternalId_external";
    GraphQLOperations["GET_PRICING_V2"] = "getPricingV2_external";
    GraphQLOperations["GET_PRICING_BY_EXTERNALID"] = "getPricingByExternalId_external";
    GraphQLOperations["GET_ORDER_DETAILS"] = "getNextInteraction_orderDetails";
    GraphQLOperations["GET_MOP_DETAILS"] = "getNextInteraction_mopDetails";
    GraphQLOperations["GET_TAX_QUOTE"] = "getNextInteraction_taxQuote";
    GraphQLOperations["GET_AUTH_STATE"] = "getNextInteraction_authState";
    GraphQLOperations["NONE"] = "none";
})(GraphQLOperations = exports.GraphQLOperations || (exports.GraphQLOperations = {}));
var Level;
(function (Level) {
    Level["ERROR"] = "ERROR";
    Level["INFO"] = "INFO";
    Level["WARN"] = "WARN";
    Level["FATAL"] = "FATAL";
})(Level = exports.Level || (exports.Level = {}));
var GRAPHQL_BAD_REQUEST_ERRORS;
(function (GRAPHQL_BAD_REQUEST_ERRORS) {
    GRAPHQL_BAD_REQUEST_ERRORS["GRAPHQL_PARSE_FAILED"] = "GRAPHQL_PARSE_FAILED";
    GRAPHQL_BAD_REQUEST_ERRORS["GRAPHQL_VALIDATION_FAILED"] = "GRAPHQL_VALIDATION_FAILED";
    GRAPHQL_BAD_REQUEST_ERRORS["BAD_USER_INPUT"] = "BAD_USER_INPUT";
})(GRAPHQL_BAD_REQUEST_ERRORS = exports.GRAPHQL_BAD_REQUEST_ERRORS || (exports.GRAPHQL_BAD_REQUEST_ERRORS = {}));
var GRAPHQL_AUTHENTICATION_ERRORS;
(function (GRAPHQL_AUTHENTICATION_ERRORS) {
    GRAPHQL_AUTHENTICATION_ERRORS["FORBIDDEN"] = "FORBIDDEN";
    GRAPHQL_AUTHENTICATION_ERRORS["UNAUTHENTICATED"] = "UNAUTHENTICATED";
})(GRAPHQL_AUTHENTICATION_ERRORS = exports.GRAPHQL_AUTHENTICATION_ERRORS || (exports.GRAPHQL_AUTHENTICATION_ERRORS = {}));
var ProductName;
(function (ProductName) {
    ProductName["CHEGG_STUDY"] = "CHEGG_STUDY";
    ProductName["CHEGG_MATH"] = "CHEGG_MATH";
    ProductName["CHEGG_STUDY_PACK"] = "CHEGG_STUDY_PACK";
})(ProductName = exports.ProductName || (exports.ProductName = {}));
var ProductType;
(function (ProductType) {
    ProductType["EASYBIB"] = "EASYBIB";
    ProductType["CHEGG_STUDY"] = "CHEGG_STUDY";
    ProductType["CHEGG_MATH"] = "CHEGG_MATH";
    ProductType["BUNDLE"] = "BUNDLE";
    ProductType["CENGAGE_UNLIMITED"] = "CENGAGE_UNLIMITED";
    ProductType["MHE_BUNDLE"] = "MHE_BUNDLE";
    ProductType["PROMOTIONS"] = "PROMOTIONS";
    ProductType["MATHWAY"] = "MATHWAY";
    ProductType["BIBME"] = "BIBME";
    ProductType["CTFM"] = "CTFM";
    ProductType["CITATIONMACHINE"] = "CITATIONMACHINE";
    ProductType["CHEGG_WRITING"] = "CHEGG_WRITING";
    ProductType["WRITING_TOOLS"] = "EASYBIB";
    ProductType["CHEGG_STUDY_PACK"] = "BUNDLE";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var ItemType;
(function (ItemType) {
    ItemType["RECURRING_BUNDLE"] = "RECURRING_BUNDLE_ITEM";
    ItemType["RECURRING_SINGLE_ITEM"] = "FIXED_RECURRING_ITEM";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var Interactions;
(function (Interactions) {
    Interactions["DEFAULT_CHECKOUT"] = "DCO";
    Interactions["ERROR"] = "ERROR";
    Interactions["DCO_1_CLICK"] = "1CLICK";
    Interactions["DCO_1_CLICK_NO_PRIOR_ORDER"] = "1CLICK_NO_PRIOR_ORDER";
    Interactions["OTHER"] = "OTHER";
})(Interactions = exports.Interactions || (exports.Interactions = {}));
var VendorType;
(function (VendorType) {
    VendorType["CHEGG"] = "CHEGG";
    VendorType["RECURLY"] = "RECURLY";
})(VendorType = exports.VendorType || (exports.VendorType = {}));
var OrderStates;
(function (OrderStates) {
    OrderStates["CANCELLED"] = "cancelled";
    OrderStates["PAUSED"] = "paused";
    OrderStates["PENDING_PAUSE"] = "pendingPause";
    OrderStates["PENDING_CANCEL"] = "pendingCancel";
    OrderStates["ACTIVE"] = "active";
})(OrderStates = exports.OrderStates || (exports.OrderStates = {}));
exports.SKIP_OPERATION_NAME_CHECK = [
    GraphQLOperations.GET_PRICING_BY_EXTERNALID.toString(),
    GraphQLOperations.GET_PRICING_V2.toString(),
    GraphQLOperations.GET_AUTH_STATE.toString(),
    GraphQLOperations.GET_MOP_DETAILS.toString(),
    GraphQLOperations.GET_ORDER_DETAILS.toString(),
    GraphQLOperations.GET_TAX_QUOTE.toString(),
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/common/interfaces.js
// module id = 298
// module chunks = 11